import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Client } from 'app/models/client';
import { ClientService } from '../client.service';
import { ActiveModal } from '../../core/modal.service';

@Component({
  selector: 'cw-edit-client-modal',
  templateUrl: './edit-client-modal.component.html',
  styleUrls: ['./edit-client-modal.component.scss']
})
export class EditClientModalComponent {
  form: FormGroup;
  opened: boolean;
  client?: Client;
  isSaving: boolean = false;
  errorMessage: string;

  constructor(private fb: FormBuilder,
              private clientService: ClientService,
              public activeModal: ActiveModal) {
    this.buildForm();
  }

  initCreate() {
    this.opened = true;
  }

  initEdit(client: Client) {
    this.client = client;
    this.form.setValue({
      name: this.client.name,
      slug: this.client.slug
    });
    this.opened = true;
  }

  save() {
    const values = this.form.value;

    this.isSaving = true;
    this.errorMessage = null;

    if (this.client) {
      this.clientService.update(this.client, values)
        .finally(() => this.isSaving = false)
        .subscribe(client => {
          this.activeModal.close(client);
        });
    } else {
      this.clientService.create(values)
        .finally(() => this.isSaving = false)
        .subscribe(
          client => {
            this.activeModal.close(client);
          }, response => {
            this.errorMessage = response.error.message;
          });
    }
  }

  deleteClient() {
    if (!confirm()) {
      return;
    }

    this.isSaving = true;

    this.clientService.deleteClient(this.client)
      .finally(() => this.isSaving = false)
      .subscribe(() => {
        this.activeModal.close();
      })
  }

  private buildForm() {
    this.form = this.fb.group({
      'name': ['', Validators.required],
      'slug': ['', Validators.required]
    });

    this.form.get('name').valueChanges.subscribe(name => {
      if (!this.client) {
        this.clientService.generateSlug(name).subscribe(slug => {
          this.form.patchValue({ slug: slug });
        });
      }
    })
  }

  get isExisting() {
    return this.client && !!this.client.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/edit-client-modal/edit-client-modal.component.ts